import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { debounceTime, tap } from 'rxjs';
import { CompanyStatus } from 'src/app/interfaces/company';
import { GroupService } from 'src/app/services/groupservice.service';
import {
  CATEGORY_OPTIONS_ALLIED,
  LIST_COMPANY_COLUMN,
} from 'src/app/shared/data/data';
import { RequestStatus } from 'src/app/shared/data/models';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-list-compani',
  templateUrl: './list-compani.component.html',
  styleUrls: ['./list-compani.component.scss'],
})
export class ListCompanyComponent implements OnInit, OnDestroy {
  @Input() public idGroup: string;
  @Input() public filterValue: string = '';
  private subs = new SubSink();
  public displayedColumns: string[] = LIST_COMPANY_COLUMN;
  public dataSource = new MatTableDataSource<any[]>([]);
  public flags = CATEGORY_OPTIONS_ALLIED;
  public list: any[] = [];
  public companyList: any;

  public page = 1;
  public size = 10;
  public totalItems = 0;
  public search = '';
  public pageIndex: number = 0;
  public pageEvent: PageEvent;

  public validator: number;
  public subscribe: any;
  public statusDetail: RequestStatus = 'init';

  public CompanyStatus: CompanyStatus;

  constructor(
    private router: Router,
    private groupService: GroupService
  ) {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.getListCompany();
    this.groupService.shareName
      .pipe(debounceTime(1000))
      .subscribe((name: string) => {
        this.search = name;
        this.getListCompany();
      });

    this.subs.sink = this.groupService.Refreshrequired.subscribe(() => {
      this.getListCompany();
    });

    this.subs.sink = this.groupService.filterByStatusCompany$.subscribe(
      (search: string) => {
        let statusLabels: any = {
          Activo: 'active',
          'Pre-registrado': 'pre_registered',
          Registrado: 'registered',
          Abandono: 'disabled',
          Finalizado: 'finished',
          Tribu: 'tribe',
          all: '',
        };

        const filter = statusLabels[search];

        if (filter != '') {
          this.getListCompany(filter);
        } else {
          this.getListCompany();
        }
      }
    );
  }

  private getListCompany(filter?: string): void {
    this.statusDetail = 'loading';
    this.subs.sink = this.groupService
      .getListCompanyByGroup(this.search, this.page, this.size, this.idGroup)
      .pipe(tap(() => (this.statusDetail = 'loading')))
      .subscribe((rta: any) => {
        const { totalItems, ItemsPage, currentPage, find } = rta;
        this.page = currentPage;
        this.size = ItemsPage;
        this.totalItems = totalItems;

        if (filter) {
          this.companyList = find.filter(
            (elements: any) => elements.company.status === filter
          );
          this.dataSource = new MatTableDataSource(this.companyList);
        } else {
          this.companyList = find;
          this.dataSource = new MatTableDataSource(find);
        }
        this.statusDetail = 'success';
      });
  }

  public goToDetails(id: string): void {
    this.router.navigate([`pages/userdash/company/${id}`], {
      queryParams: { idGroup: this.idGroup },
    });
  }

  public handlePageEvent(ev: PageEvent): void {
    this.groupService
      .getListCompanyByGroup(
        this.search,
        ev.pageIndex + 1,
        ev.pageSize,
        this.idGroup
      )
      .pipe(tap(() => (this.statusDetail = 'loading')))
      .subscribe((rta: any) => {
        const { totalItems, ItemsPage, currentPage, find } = rta;
        this.page = currentPage;
        this.size = ItemsPage;
        this.totalItems = totalItems;
        this.statusDetail = 'success';
        this.companyList = find;
        this.dataSource = new MatTableDataSource(find);
      });
  }

  statusText(status: CompanyStatus): string {
    switch (status) {
      case CompanyStatus.Active:
        return 'COMPANY.active';
      case CompanyStatus.PreRegistered:
        return 'COMPANY.preRegistered';
      case CompanyStatus.Registered:
        return 'COMPANY.registered';
      case CompanyStatus.Finalized:
        return 'COMPANY.finalized';
      case CompanyStatus.Tribe:
        return 'COMPANY.tribe';
      case CompanyStatus.Abandonment:
        return 'COMPANY.abandonment';
    }
  }

  public validateTypeBussinesCompanie(companie: any): string {
    let typeBussines = companie.selling;
    let bussines: string = '';
    typeBussines.products == true ? (bussines = 'Productos') : null;
    typeBussines.resale == true ? (bussines = 'Reventas') : null;
    typeBussines.services == true ? (bussines = 'Servicios') : null;
    return bussines;
  }

  public sortByDownName(): void {
    let newOrder = this.dataSource.data.sort((a: any, b: any) => {
      const nameA = a.names.toUpperCase();
      const nameB = b.names.toUpperCase();
      return nameB.localeCompare(nameA);
    });
    this.dataSource.data = newOrder;
  }

  public sortByName(): void {
    let newOrder = this.dataSource.data.sort((a: any, b: any) => {
      const nameA = a.names.toUpperCase();
      const nameB = b.names.toUpperCase();
      return nameA.localeCompare(nameB);
    });
    this.dataSource.data = newOrder;
  }

  public sortByDownBussines(): void {
    let newOrder = this.dataSource.data.sort((a: any, b: any) => {
      const nameA = a.company_name;
      const nameB = b.company_name;
      return nameB.localeCompare(nameA);
    });
    this.dataSource.data = newOrder;
  }

  public sortByBussines(): void {
    let newOrder = this.dataSource.data.sort((a: any, b: any) => {
      const nameA = a.company_name;
      const nameB = b.company_name;
      return nameA.localeCompare(nameB);
    });
    this.dataSource.data = newOrder;
  }
}
